import repositories from '@/repositories'

interface SendOTP {
  type?: string
  value?: string
  name?: string
  otpFor?:string
  recaptchaToken?:string
  uuid?: string
  provider?: string
}

export const register = async (user: any) => {
  try {
    const res = await repositories.session.signup(user)
    return res
  } catch (err) {
    return err
  }
}

export const sendOtp = async ({ type, value, name, otpFor, recaptchaToken, uuid, provider }: SendOTP) => {
  try {
    const res = await repositories.session.sendOtp({
      type,
      value,
      name,
      otpFor,
      recaptchaToken,
      uuid,
      provider
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
